<template>
  <div class="">
    <create-cash-entries-default> </create-cash-entries-default>
  </div>
</template>

<script>
import CreateCashEntriesDefault from "@/components/accounting/cash-entries/book-entries/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    CreateCashEntriesDefault,
  },
  created() {
    this.notifyQueue({
      text: "Crea Movimento Contabile",
      path: "movimenti_prima_nota.create0",
      level: 4,
    });
  },
};
</script>
